import DocumentsListView from "../../../../../components/modules/documentsListView/DocumentsListView";
import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";

export default function ViewDocumentDetail() {
  const { _case } = useParentLoaderData();
  return (
    <Navigation activeTab="documents" _case={_case}>
      <div
        className="h-[calc(100vh-5rem)] bg-white"
        style={{ boxShadow: "3px 3px 10px 0px rgba(188, 209, 255, 1)" }}
      >
        <DocumentsListView />
      </div>
    </Navigation>
  );
}
